import { makeAutoObservable, runInAction } from "mobx";
import RootStore from "../../../stores/RootStore";

export default class HoldManagementStore {
    // Observables
    isLoading = false;
    error: string | null = null;
    holds: any[] = [];
    currentHold: any = null;

    // Constructor
    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    // Actions
    setLoading(loading: boolean) {
        this.isLoading = loading;
    }

    setError(error: string | null) {
        this.error = error;
    }

    // Async actions
    async loadHolds(holdId?: string) {
        try {
            this.setLoading(true);
            this.setError(null);

            // Mock data for now
            const mockHolds = [
                {
                    id: "hold-1",
                    title: "Material Quality Issue",
                    description: "Quality issue with concrete batch",
                    status: "Active",
                    priority: "High",
                    createdDate: "2024-07-05",
                },
                {
                    id: "hold-2",
                    title: "Equipment Maintenance",
                    description: "Scheduled maintenance on production line",
                    status: "Resolved",
                    priority: "Medium",
                    createdDate: "2024-07-03",
                },
            ];

            runInAction(() => {
                this.holds = mockHolds;
                if (holdId) {
                    this.currentHold = mockHolds.find(h => h.id === holdId) || null;
                }
            });
        } catch (error: any) {
            runInAction(() => {
                this.setError(error.message || "Failed to load holds");
            });
        } finally {
            this.setLoading(false);
        }
    }

    // Computed values
    get activeHolds() {
        return this.holds.filter(hold => hold.status === "Active");
    }

    get hasActiveHolds() {
        return this.activeHolds.length > 0;
    }
}
